import { render, staticRenderFns } from "./PDPQuantity.vue?vue&type=template&id=5884ab23&scoped=true"
import script from "./PDPQuantity.vue?vue&type=script&lang=js"
export * from "./PDPQuantity.vue?vue&type=script&lang=js"
import style0 from "./PDPQuantity.vue?vue&type=style&index=0&id=5884ab23&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5884ab23",
  null
  
)

export default component.exports